// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__1OOJg","head":"Table_head__aUpt-","col":"Table_col__KW4Fs"};